module.exports = __webpack_public_path__ + "img/mp-img-7.f2ce72d0.jpg";